import '../styles/Loading.css';

const Loading = ({type}) => {
  return (
    <div className="loading-container">
      <h1>Analizando {type}</h1>
      <p>Estamos clasificando tu {type} según los ODS relacionados.
        <br />
        Esto podría tardar varios segundos
      </p>
      <div className="bubbles">
        <div className="bubble"></div>
        <div className="bubble"></div>
        <div className="bubble"></div>
      </div>
    </div>
  );
};

export default Loading;

